module.exports = window["core-js/modules/es.array.slice.js"];